import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterInput extends Component {
  onChange = values => {
    const { activeInputs, setMyJobsDataViewerFilter } = this.props
    const jobInputs = ArrayHelper.getArrData(values, [])

    if (!isEqual(jobInputs, activeInputs.toArray())) {
      setMyJobsDataViewerFilter({ jobInputs })
    }
  }

  render() {
    const { activeInputs, inputList } = this.props
    const values = ArrayHelper.getValues(activeInputs, inputList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: [-1],
        }}
        variant="outlined"
        name="inputs"
        label={formatMessage('inputs')}
        list={inputList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'title',
        }}
      />
    )
  }
}

FilterInput.defaultProps = {
  activeInputs: List([]),
  inputList: List([]),
}

FilterInput.propTypes = {
  activeInputs: PropTypes.instanceOf(List),
  inputList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeInputs: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobInputs',
    ]),
    inputList: store.getIn(['myJobsDataViewer', 'filters', 'inputs']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterInput)
